/**
 * Date range, [ Date, Date]
 */

 import React from 'react'
 import get from 'lodash/get'
 import dayjs from 'dayjs'
 
  const range = ({row,name}) => {
 
 
     const [ startDate, endDate ] = get( row,  name === 'name' ? 'form.name' : name , [null,null])

     return <><div>{startDate && dayjs(startDate).format('L')}</div><div>{endDate && dayjs(endDate).format('L')}</div></>
 }
 
 export default range